/* eslint-disable no-unused-vars */
import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import sample1 from '../assets/images/sample1.jpeg';


const Hero = () => {
  return (
    <Box 
      className="hero-section"
      sx={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${sample1})`
      }}
    >
      <Container maxWidth="md">
        <Box className="text-center text-white hero-content" sx={{ paddingTop: '3rem' }}>
          <Typography variant="h2" component="h1" className="font-bold">
            Davitt Electric
          </Typography>
          <Typography variant="h5">
            Professional Electrical Services For Your Home & Business
          </Typography>
          <Box className="flex justify-center flex-wrap" sx={{ marginTop: 'var(--space-lg)' }}>
            <Typography variant="h6" className="text-center max-w-lg" sx={{ color: '#ffffff', fontWeight: 300, letterSpacing: '0.02em' }}>
              Licensed, bonded, and insured electrical services with 24/7 emergency support. 
              Proudly serving residents and businesses with quality workmanship.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;